import { Badge } from "@mantine/core";

import { DEPRECATED_FLAG_LABEL } from "../constants/client-flags";

/**
 * The chip a flag wears once its library entry has been deleted.
 *
 * It takes the priority's place on every surface that shows a flag, so the row keeps one trailing
 * signal rather than two. Outlined and neutral, because a deprecated flag is not a tier — it is a
 * flag whose tier no longer comes from anywhere the practice maintains.
 */
export default function FlagDeprecatedBadge() {
  return (
    <Badge
      fz="sm"
      radius="xl"
      color="gray.5"
      variant="outline"
      data-testid="flag-deprecated-badge"
      styles={{
        label: {
          fontWeight: 500,
          textTransform: "none",
          color: "var(--mantine-color-gray-7)",
        },
      }}
    >
      {DEPRECATED_FLAG_LABEL}
    </Badge>
  );
}
